import { ButtonProps } from "@mui/material";
import ZoomButton from "app/frontend/components/buttons/ZoomButton";

const ContainedZoomButton: React.FC<ButtonProps> = ({ children, sx, ...props }) => {
    return (
        <ZoomButton
            variant="contained"
            sx={{
                borderRadius: 10,
                boxShadow: 0,
                margin: 2,
                paddingX: 4,
                paddingY: 2,
                fontWeight: "bold",
                fontSize: "14px",
                ...sx,
            }}
            {...props}
        >
            {children}
        </ZoomButton>
    );
};

export default ContainedZoomButton;
